import React, { FC } from 'react'

import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

import { secToHourMinute } from '../../../utils/date'

interface Props {
  openCallback: () => void
}

const WorkStyleTip: FC<Props> = (props) => {
  const {
    openCallback,
  } = props

  const {
    profile,
  } = useSelector((state: RootState) => state)

  return (
    <div className="work_style_tip">
      <div className="title">
        あなたの働き方
      </div>
      <div className="work_style_area">
        {
          profile.work_style_ids?.length ? (
            <>
              <img
                alt=""
                src={`/static/images/work_style/${profile.work_style_ids[0]}.png`}
                className="icon"
              />
              <div className="description">
                {
                  profile.work_style_ids?.length
                  && profile.work_style_list.find(
                    (work_style) => work_style.id === profile.work_style_ids[0],
                  )?.description
                }
              </div>
            </>
          ) : (
            <>
              <img
                alt=""
                src="/static/images/work_style/0.png"
                className="icon"
              />
              <div className="description">
                未設定
              </div>
            </>
          )
        }
      </div>
      <div className="work_style_area">
        {
          profile.occupation_id ? (
            <>
              <img
                alt=""
                src={`/static/images/occupation/${profile.occupation_id}.png`}
                className="icon"
              />
              <div className="description">
                {
                  profile.occupationList.find((occupation) => occupation.id === profile.occupation_id)?.description
                }
              </div>
            </>
          ) : (
            <>
              <img
                alt=""
                src="/static/images/occupation/0.png"
                className="icon"
              />
              <div className="description">
                未設定
              </div>
            </>
          )
        }
      </div>
      <div className="title">
        標準勤務時間
      </div>
      <div className="dummy_input">
        <div>
          {secToHourMinute(profile.base_work_time)}
        </div>
        {
          profile.base_inactive_time ? (
            <div>
              {`(休憩時間${secToHourMinute(profile.base_inactive_time)}を含む)`}
            </div>
          ) : (
            <></>
          )
        }
      </div>
      <div className="button_area">
        <button
          type="button"
          onClick={openCallback}
        >
          設定
        </button>
      </div>
    </div>
  )
}

export default WorkStyleTip
